import { render, staticRenderFns } from "./DrawerNavigation.vue?vue&type=template&id=36870a27&scoped=true"
import script from "./DrawerNavigation.vue?vue&type=script&lang=js"
export * from "./DrawerNavigation.vue?vue&type=script&lang=js"
import style0 from "./DrawerNavigation.vue?vue&type=style&index=0&id=36870a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36870a27",
  null
  
)

export default component.exports